import { ChevronLeft, ChevronRight } from 'lucide-react';

interface CarouselNavigationProps {
  onPrev: () => void;
  onNext: () => void;
}

export const CarouselNavigation = ({ onPrev, onNext }: CarouselNavigationProps) => (
  <>
    <button
      className="absolute left-4 top-1/2 z-30 flex -translate-y-1/2 items-center justify-center rounded-full bg-black/20 p-2 transition-all hover:bg-black/40 md:left-4"
      onClick={onPrev}
    >
      <ChevronLeft className="text-white" size={24} />
    </button>
    <button
      className="absolute right-4 top-1/2 z-30 flex -translate-y-1/2 items-center justify-center rounded-full bg-black/20 p-2 transition-all hover:bg-black/40 md:right-4"
      onClick={onNext}
    >
      <ChevronRight className="text-white" size={24} />
    </button>
  </>
);

export const CarouselNavigationMobile = ({ onPrev, onNext }: CarouselNavigationProps) => (
  <>
    <button
      className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center justify-center rounded-full bg-white p-2 transition-all hover:scale-110"
      onClick={onPrev}
    >
      <ChevronLeft className="font-bold text-primary" size={24} strokeWidth={3} />
    </button>
    <button
      className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center justify-center rounded-full bg-white p-2 transition-all hover:scale-110"
      onClick={onNext}
    >
      <ChevronRight className="font-bold text-primary" size={24} strokeWidth={3} />
    </button>
  </>
);
